import { ReactElement } from "react";

import { Spinner } from "@/v1/components/atoms/Spinner/Spinner";
import { useTranslation } from "@/v2/hooks/useTranslation";

/** Waiting for the provider. */
export const FreeSpinsRetrievalRunning = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="fs-retrieval__running">
      <Spinner />
      <p>{t("free-spin.fs-retrieval-modal.running")}</p>
    </div>
  );
};
